import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, TextField } from '@mui/material';
import { getSearchableListData } from '../../services/coupon-code-categories.service';

const CouponCodeCategories = ({
  id,
  name,
  label,
  defaultValue,
  multiple,
  disabled,
  onChange,
  sx,
  error,
  showAllOptions,
}) => {
  const selectedValue = defaultValue || (multiple ? [] : null);

  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState(selectedValue);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (showAllOptions && !selectedValue) {
      setValue({ id: null, name: 'All' });
    } else {
      setValue(selectedValue);
    }
  }, [selectedValue]);

  useEffect(() => {
    getSearchableListData()
      .then((res) => {
        const optionsData = res.data || [];
        if (showAllOptions) {
          optionsData.unshift({ id: null, name: 'All' });
        }
        setOptions(optionsData);
        setLoading(false);
      })
      .catch(() => {
        // upon error, show loading only
      });
  }, []);

  return (
    <Autocomplete
      id={id}
      name={name}
      options={options}
      getOptionLabel={(option) => `${option.name}`}
      sx={sx}
      value={value}
      onChange={(e, v) => {
        setValue(v);
        onChange(v);
      }}
      inputValue={inputValue}
      onInputChange={(e, v) => {
        setInputValue(v);
      }}
      multiple={multiple}
      disabled={disabled}
      loading={loading}
      isOptionEqualToValue={(op, vl) => op.id === vl.id}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={error !== ''}
          helperText={error}
          variant="filled"
        />
      )}
      disableClearable={showAllOptions}
    />
  );
};

CouponCodeCategories.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.any,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.shape(),
  error: PropTypes.string,
  showAllOptions: PropTypes.bool,
};
CouponCodeCategories.defaultProps = {
  multiple: false,
  disabled: false,
  sx: {},
  defaultValue: null,
  error: '',
  showAllOptions: false,
};

export default CouponCodeCategories;
